<div class="focus-offering-form">
  <div class="offering-form-header">
    <a rds-link standalone routerLink="/focus/my-offerings" class="mb-5">
      <rds-icon namespace="filled" icon="arrow_left" />
      {{ BUTTONS.BACK_TO_MY_OFFERINGS }}
    </a>

    <div class="title-row">
      @if (!offeringUUID()) {
      <h2 class="ui-heading-3-bold">{{ OFFERING_FORM.HEADERS.ADD_NEW }}</h2>
      } @else {
      <h2 class="ui-heading-3-bold">
        {{ OFFERING_FORM.HEADERS.EDIT }} {{ offeringName() }}
      </h2>
      }
      <button *inexpFeatureFlag="'focus_inexp_1361_save_draft'" rds-secondary-button (click)="handleDraftSave()" size="l"
        [disabled]="isDraftSaving()">
        @if (isDraftSaving()) {
        <div class="loading-container">
          <rds-progress-spinner class="loading-spinner"></rds-progress-spinner>
          {{ BUTTONS.DRAFT_SAVING }}
        </div>
        } @else {
        {{ BUTTONS.SAVE_DRAFT }}
        }
      </button>
    </div>

    <div>
      <rds-badge
        size="s"
        type="minimal"
        color="blue"
        class="platform-badge"
        [label]="OFFERING_FORM.HEADERS.OFFERING_TYPE">
      </rds-badge>
      <rds-badge
        size="s"
        type="minimal"
        color="blue"
        [label]="getContentStatusLabel(offering()?.publishedAt, offering()?.updatedAt)">
      </rds-badge>
    </div>
  </div>
  <div class="offering-form-content">
    @if (isLoading()) {
    <inexp-form-skeleton />
    } @else {
    <rds-stepper #stepper>
      <!-- 1 -->
      <rds-step [stepControl]="formPermissions" label="step_1_rolesAndPermissions">
        <ng-template rdsStepLabel>{{ OFFERING_FORM.STEPS.STEP_1 }}</ng-template>
        <form class="form" [formGroup]="formPermissions">
          <fieldset class="form-box">
            <h3 class="ui-heading-3-bold mb-5 required">
              {{ OFFERING_FORM.PERMISSIONS.OWNER.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Owner email -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.PERMISSIONS.OWNER.LABEL
                  }}</rds-control-label>
                <input rdsInput formControlName="ownerEmail"
                  [placeholder]="OFFERING_FORM.PERMISSIONS.OWNER.PLACEHOLDER" />
                <rds-control-hint>{{
                  OFFERING_FORM.PERMISSIONS.OWNER.HINT
                  }}</rds-control-hint>

                @if (
                formPermissions.controls.ownerEmail.touched &&
                formPermissions.controls.ownerEmail.hasError("required")
                ) {
                <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
                }
                @if (
                formPermissions.controls.ownerEmail.touched &&
                formPermissions.controls.ownerEmail.hasError("strictEmail")
                ) {
                <rds-control-error>
                  {{ ERRORS.INVALID_EMAIL }}
                </rds-control-error>
                }
              </rds-form-field>
            </div>
          </fieldset>
          <fieldset class="form-box" aria-labelledby="offering-deputy-title">
            <h3 class="ui-heading-3-bold mb-5 required" id="offering-deputy-title">
              {{ OFFERING_FORM.PERMISSIONS.DEPUTY.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Deputy email -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.PERMISSIONS.DEPUTY.LABEL
                  }}</rds-control-label>
                <input rdsInput formControlName="deputyEmail"
                  [placeholder]="OFFERING_FORM.PERMISSIONS.DEPUTY.PLACEHOLDER" />
                <rds-control-hint>{{
                  OFFERING_FORM.PERMISSIONS.DEPUTY.HINT
                  }}</rds-control-hint>
                @if (
                formPermissions.controls.deputyEmail.touched &&
                formPermissions.controls.deputyEmail.hasError("required")
                ) {
                <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
                }
                @if (
                formPermissions.controls.deputyEmail.touched &&
                formPermissions.controls.deputyEmail.hasError("strictEmail")
                ) {
                <rds-control-error>
                  {{ ERRORS.INVALID_EMAIL }}
                </rds-control-error>
                }
              </rds-form-field>
            </div>
          </fieldset>
          <fieldset class="form-box" aria-labelledby="offering-author-title">
            <h3 class="ui-heading-3-bold mb-5 required" id="offering-author-title">
              {{ OFFERING_FORM.PERMISSIONS.AUTHOR.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Author's email -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.PERMISSIONS.AUTHOR.LABEL
                  }}</rds-control-label>

                <rds-input-with-chips formControlName="authorEmails">
                  <rds-chip-grid>
                    @for (author of authors(); track $index) {
                    <rds-input-chip editable [value]="author" (edited)="onEditAuthor(author, $event)"
                      (closeChip)="removeAuthor(author)">
                      {{ author }}
                    </rds-input-chip>
                    }
                    <input rds-input rdsChipInput #authorInput (rdsChipInputTokenEnd)="addAuthor($event)"
                      (focusout)="onAuthorFocusOut(authorInput)" [placeholder]="
                        OFFERING_FORM.PERMISSIONS.AUTHOR.PLACEHOLDER
                      " />
                  </rds-chip-grid>
                </rds-input-with-chips>
                <rds-control-hint>{{
                  OFFERING_FORM.PERMISSIONS.AUTHOR.HINT
                  }}</rds-control-hint>
                @if (
                formPermissions.controls.authorEmails.touched &&
                formPermissions.controls.authorEmails.hasError("required")
                ) {
                <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
                }

                @if (
                formPermissions.controls.authorEmails.touched &&
                formPermissions.controls.authorEmails.hasError("emailList")
                ) {
                <rds-control-error>
                  {{ ERRORS.INVALID_EMAIL }}
                </rds-control-error>
                }
              </rds-form-field>
            </div>
          </fieldset>
        </form>
        <div class="form-action publish-and-next">
          @if (offeringUUID()) {
          <button rds-secondary-button (click)="handlePublish()" size="l" [disabled]="isPublishing()">
            @if (isPublishing()) {
            <div class="loading-container">
              <rds-progress-spinner class="loading-spinner"></rds-progress-spinner>
              {{ BUTTONS.PUBLISHING }}
            </div>
            } @else {
            {{ BUTTONS.PUBLISH }}
            }
          </button>
          }
          <button rds-primary-button rdsStepperNext size="l">
            {{ BUTTONS.NEXT_STEP }}
          </button>
        </div>
      </rds-step>

      <!-- 2 -->
      <rds-step [stepControl]="formOverview" label="step_2_offeringOverview">
        <ng-template rdsStepLabel>{{ OFFERING_FORM.STEPS.STEP_2 }}</ng-template>
        <form [formGroup]="formOverview" class="form">
          <fieldset class="form-box" aria-labelledby="general-info-title">
            <h3 class="ui-heading-3-bold mb-5 required" id="general-info-title">
              {{ OFFERING_FORM.OVERVIEW.GENERAL_INFO.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Display name -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.OVERVIEW.GENERAL_INFO.DISPLAY_NAME.LABEL
                  }}</rds-control-label>
                <input rdsInput formControlName="displayName" [placeholder]="
                    OFFERING_FORM.OVERVIEW.GENERAL_INFO.DISPLAY_NAME.PLACEHOLDER
                  " />
                <rds-control-hint>{{
                  OFFERING_FORM.OVERVIEW.GENERAL_INFO.DISPLAY_NAME.HINT
                  }}</rds-control-hint>
                @if (
                formOverview.controls.displayName.touched &&
                formOverview.controls.displayName.hasError("required")
                ) {
                <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
                }
                @if (
                formOverview.controls.displayName.touched &&
                formOverview.controls.displayName.hasError("slugLength")
                ) {
                <rds-control-error>{{
                  ERRORS.SLUG_LENGTH
                  }}</rds-control-error>
                }
                @if (
                formOverview.controls.displayName.touched &&
                formOverview.controls.displayName.hasError("slugDuplicate")
                ) {
                <rds-control-error>{{
                  ERRORS.SLUG_DUPLICATE
                  }}</rds-control-error>
                }
              </rds-form-field>
              <!-- Approval status -->
              <rds-form-field labelPosition="top"><rds-control-label>{{
                  OFFERING_FORM.OVERVIEW.GENERAL_INFO.APPROVAL_STATUS.LABEL
                  }}</rds-control-label>
                <rds-select formControlName="approvalStatus" [placeholder]="
                    OFFERING_FORM.OVERVIEW.GENERAL_INFO.APPROVAL_STATUS
                      .PLACEHOLDER
                  ">
                  @for (
                  approvalStatus of approvalStatuses;
                  track approvalStatus
                  ) {
                  <rds-select-option [value]="approvalStatus">{{
                    approvalStatus
                    }}</rds-select-option>
                  }
                </rds-select>
                <rds-control-hint>{{
                  OFFERING_FORM.OVERVIEW.GENERAL_INFO.APPROVAL_STATUS.HINT
                  }}</rds-control-hint>
                @if (
                formOverview.controls.approvalStatus.touched &&
                formOverview.controls.approvalStatus.errors
                ) {
                <rds-control-error>
                  {{ ERRORS.EMPTY_SELECTION }}
                </rds-control-error>
                }
              </rds-form-field>
              @if (
              formOverview.controls.approvalStatus.value !==
              ApprovalStatus.APPROVED_PREFERRED &&
              formOverview.controls.approvalStatus.value !==
              ApprovalStatus.APPROVED
              ) {
              <!-- Successor -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.OVERVIEW.GENERAL_INFO.SUCCESSOR.LABEL
                  }}</rds-control-label>
                <rds-select formControlName="successor" [placeholder]="
                      OFFERING_FORM.OVERVIEW.GENERAL_INFO.SUCCESSOR.PLACEHOLDER
                    " #select (valueChange)="select.resetFilterValue()" [filterBy]="filterBy">
                  <rds-select-search-input></rds-select-search-input>
                  <rds-select-option-separator></rds-select-option-separator>
                  @for (offering of offerings(); track offering.uuid) {
                  <rds-select-option [value]="offering.uuid">{{
                    offering.displayName
                    }}</rds-select-option>
                  }
                </rds-select>
                <rds-control-hint>{{
                  OFFERING_FORM.OVERVIEW.GENERAL_INFO.SUCCESSOR.HINT
                  }}</rds-control-hint>
              </rds-form-field>
              }
            </div>
          </fieldset>
          <fieldset class="form-box" aria-labelledby="offering-description-title">
            <h3 class="ui-heading-3-bold mb-5 required" id="offering-description-title">
              {{ OFFERING_FORM.OVERVIEW.DESCRIPTION.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Offering description -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.OVERVIEW.DESCRIPTION.LABEL
                  }}</rds-control-label>
                <textarea rdsInput formControlName="description"
                  [placeholder]="OFFERING_FORM.OVERVIEW.DESCRIPTION.PLACEHOLDER"></textarea>
                <rds-control-hint>{{
                  OFFERING_FORM.OVERVIEW.DESCRIPTION.HINT
                  }}</rds-control-hint>
                @if (
                formOverview.controls.description.touched &&
                formOverview.controls.description.errors
                ) {
                <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
                }
              </rds-form-field>
            </div>
          </fieldset>
          <fieldset class="form-box" aria-labelledby="similar-offerings-title">
            <h3 class="ui-heading-3-bold mb-5" id="similar-offerings-title">
              {{ OFFERING_FORM.OVERVIEW.SIMILAR_OFFERINGS.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Similar offerings -->
              <rds-form-field labelPosition="top"><rds-control-label>{{
                  OFFERING_FORM.OVERVIEW.SIMILAR_OFFERINGS.LABEL
                  }}</rds-control-label>
                <rds-multi-autocomplete formControlName="similarOfferings" [options]="similarOfferingOptions()"
                  displayProperty="displayName" uniqProperty="uuid" [compareItem]="compareOfferings"
                  [filterBy]="filterOfferings" [placeholder]="
                    OFFERING_FORM.OVERVIEW.SIMILAR_OFFERINGS.PLACEHOLDER
                  " [minSearchChars]="0" [debounce]="0" multiMinimumInputWidth="125" />
                <rds-control-hint>{{
                  OFFERING_FORM.OVERVIEW.SIMILAR_OFFERINGS.HINT
                  }}</rds-control-hint>
              </rds-form-field>
            </div>
          </fieldset>
        </form>
        <div class="form-actions">
          <button rds-secondary-button rdsStepperPrevious size="l">
            {{ BUTTONS.PREVIOUS_STEP }}
          </button>
          <div class="publish-and-next">
            @if (offeringUUID()) {
            <button rds-secondary-button (click)="handlePublish()" size="l" [disabled]="isPublishing()">
              @if (isPublishing()) {
              <div class="loading-container">
                <rds-progress-spinner class="loading-spinner"></rds-progress-spinner>
                {{ BUTTONS.PUBLISHING }}
              </div>
              } @else {
              {{ BUTTONS.PUBLISH }}
              }
            </button>
            }
            <button rds-primary-button rdsStepperNext size="l">
              {{ BUTTONS.NEXT_STEP }}
            </button>
          </div>
        </div>
      </rds-step>

      <!-- 3 -->
      <rds-step [stepControl]="formDetails" label="step_3_offeringDetails">
        <ng-template rdsStepLabel>{{ OFFERING_FORM.STEPS.STEP_3 }}</ng-template>
        <form [formGroup]="formDetails" class="form">
          <!-- ONBOARDING INFORMATION -->
          <fieldset class="form-box" aria-labelledby="onboarding-information-title">
            <h3 class="ui-heading-3-bold mb-5 required" id="onboarding-information-title">
              {{ OFFERING_FORM.DETAILS.ONBOARDING.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <div class="dialog-description">
                <rds-control-label>{{ OFFERING_FORM.DETAILS.ONBOARDING.ACCESS_INSTRUCTIONS.LABEL }}
                  <span class="rich-editor-field-asterisk"> * </span>
                </rds-control-label>
                <app-rich-text-editor formControlName="onboardingAccessInstructions"
                  [placeholder]="OFFERING_FORM.DETAILS.ONBOARDING.ACCESS_INSTRUCTIONS.PLACEHOLDER" [readonly]="false"
                  [minHeight]="200" [invalid]="formDetails.controls.onboardingAccessInstructions.touched && formDetails.controls.onboardingAccessInstructions.invalid">
                </app-rich-text-editor>
                @if (formDetails.controls.onboardingAccessInstructions.touched && formDetails.controls.onboardingAccessInstructions.invalid) {
                <div class="editor-error">
                  <rds-icon namespace="outlined" icon="warning_circle"></rds-icon>
                  <span>{{ ERRORS.EMPTY }}</span>
                </div>
                } @else {
                <rds-control-hint>
                  {{ POPUPS.COMMUNITY.DESCRIPTION_HINT }}
                </rds-control-hint>
                }
              </div>
            </div>
            <span class="ui-label-m-bold required mt-5">
              {{ OFFERING_FORM.DETAILS.ONBOARDING.LABEL }}
            </span>
            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.DETAILS.ONBOARDING.HINT }}
            </p>
            <table rds-table [dataSource]="onboardingDataSource" alternation="vertical">
              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                  OFFERING_FORM.DETAILS.ONBOARDING.TABLE_COLUMNS
                  .STEP_DESCRIPTION
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.description }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="referenceUrl">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                  OFFERING_FORM.DETAILS.ONBOARDING.TABLE_COLUMNS.ACCESS_URL
                  }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  <span>{{ element.referenceUrl }}</span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button rds-dropdown-toggle-icon-button aria-label="More options" type="button">
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button rds-list-item (click)="handleOnboardingDialog(element)">
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button rds-list-item (click)="handleDeleteOnboardingStep(element)">
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="onboardingColumns"></tr>
              <tr rds-row *rdsRowDef="let row; columns: onboardingColumns"></tr>
            </table>
            <button class="table-action" rds-text-button (click)="handleOnboardingDialog()">
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.DETAILS.ONBOARDING.CTA }}
            </button>
          </fieldset>

          <!-- SERVICES & REQUESTS -->
          <fieldset class="form-box" aria-labelledby="offering-service-request-title">
            <h3 class="ui-heading-3-bold mb-5 required" id="offering-service-request-title">
              {{ OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.SECTION_TITLE }}
            </h3>
            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.HINT }}
            </p>
            <table rds-table [dataSource]="serviceAndRequestDataSource" alternation="vertical">
              <ng-container rdsColumnDef="type">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                  OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS.TYPE
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.type }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="title">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                  OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                  .TITLE
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.title }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="destinationValue">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                  OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                  .DESTINATION
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.destinationValue }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                  OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                  .DESCRIPTION
                  }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  {{ element.description }}
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button rds-dropdown-toggle-icon-button aria-label="More options" type="button">
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button rds-list-item (click)="handleServiceAndRequestDialog(element)">
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button rds-list-item (click)="handleDeleteServiceAndRequest(element)">
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>


              <tr rds-header-row *rdsHeaderRowDef="serviceAndRequestColumns"></tr>
              <tr rds-row *rdsRowDef="let row; columns: serviceAndRequestColumns"></tr>
            </table>

            <button class="table-action" rds-text-button (click)="handleServiceAndRequestDialog()">
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.CTA }}
            </button>
          </fieldset>

          <!-- VENDOR INFORMATION -->
          <fieldset class="form-box" aria-labelledby="offering-vendor-title">
            <h3 class="ui-heading-3-bold mb-5" id="offering-vendor-title">
              {{ OFFERING_FORM.DETAILS.VENDOR.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <rds-form-field labelPosition="top" hideRequiredMarker>
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.VENDOR.NAME.LABEL
                  }}</rds-control-label>
                <input rdsInput formControlName="vendorName"
                  [placeholder]="OFFERING_FORM.DETAILS.VENDOR.NAME.PLACEHOLDER" />
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.VENDOR.NAME.HINT
                  }}</rds-control-hint>
              </rds-form-field>
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.VENDOR.SUPPORT.LABEL
                  }}</rds-control-label>
                <textarea rdsInput formControlName="vendorSupport" [placeholder]="
                              OFFERING_FORM.DETAILS.VENDOR.SUPPORT.PLACEHOLDER
                            "></textarea>
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.VENDOR.SUPPORT.HINT
                  }}</rds-control-hint>
              </rds-form-field>
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.VENDOR.URL.LABEL
                  }}</rds-control-label>
                <input rdsInput formControlName="vendorUrl" />
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.VENDOR.URL.HINT
                  }}</rds-control-hint>
                @if (
                formDetails.controls.vendorUrl.touched &&
                formDetails.controls.vendorUrl.hasError("invalidUrl")
                ) {
                <rds-control-error>{{
                  ERRORS.INVALID_URL
                  }}</rds-control-error>
                }
              </rds-form-field>
            </div>
          </fieldset>

          <!-- RELATED TECHNOLOGY -->
          <fieldset class="form-box" aria-labelledby="offering-related-technology-title">
            <h3 class="ui-heading-3-bold mb-5" id="offering-related-technology-title">
              {{ OFFERING_FORM.DETAILS.RELATED_TECHNOLOGY.SECTION_TITLE }}
            </h3>
            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.DETAILS.RELATED_TECHNOLOGY.HINT }}
            </p>
            <table rds-table [dataSource]="relatedTechnologyDataSource" alternation="vertical">
              <ng-container rdsColumnDef="targetId">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{ OFFERING_FORM.DETAILS.RELATED_TECHNOLOGY.TABLE_COLUMNS.NAME }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ getOfferingById()(element.targetId)?.displayName || "—" }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                  OFFERING_FORM.DETAILS.RELATED_TECHNOLOGY.TABLE_COLUMNS
                  .DESCRIPTION
                  }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  {{ element.description || "—" }}
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button rds-dropdown-toggle-icon-button aria-label="More options" type="button">
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button rds-list-item (click)="handleRelatedTechnologyDialog(element)">
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button rds-list-item (click)="handleDeleteRelatedTechnology(element)">
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="relatedTechnologyColumns"></tr>
              <tr rds-row *rdsRowDef="let row; columns: relatedTechnologyColumns"></tr>
            </table>

            <button class="table-action" rds-text-button (click)="handleRelatedTechnologyDialog()">
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.DETAILS.RELATED_TECHNOLOGY.CTA }}
            </button>
          </fieldset>

                    <!-- ADDITIONAL COST CONSIDERATIONS -->
                    <fieldset class="form-box" aria-labelledby="offering-additional-cost-cosiderations-title">
                      <h3 class="ui-heading-3-bold mb-5" id="offering-additional-cost-cosiderations-title">
                        {{ OFFERING_FORM.DETAILS.ADDITIONAL_COST.SECTION_TITLE }}
                      </h3>
                      <div class="inputs">
                        <!-- Additional cost considerations Checkbox -->

                        <!-- Pricing per user -->
                        <rds-checkbox formControlName="isAdditionalCostConsiderationsAvailable" [checked]="false">{{
                          OFFERING_FORM.DETAILS.ADDITIONAL_COST
                          .ADDITIONAL_COST_CONSIDERATIONS.CHECKBOX_LABEL
                          }}</rds-checkbox>

                        @if (
                        formDetails.controls.isAdditionalCostConsiderationsAvailable
                        .value
                        ) {
                        <!-- Additional cost considerations -->
                        <rds-form-field labelPosition="top">
                          <rds-control-label>{{
                            OFFERING_FORM.DETAILS.ADDITIONAL_COST
                            .ADDITIONAL_COST_CONSIDERATIONS.LABEL
                            }}</rds-control-label>
                          <input rdsInput formControlName="additionalCostConsiderations" [placeholder]="
                                OFFERING_FORM.DETAILS.ADDITIONAL_COST
                                  .ADDITIONAL_COST_CONSIDERATIONS.PLACEHOLDER
                              " />
                          <rds-control-hint>{{
                            OFFERING_FORM.DETAILS.ADDITIONAL_COST
                            .ADDITIONAL_COST_CONSIDERATIONS.HINT
                            }}</rds-control-hint>
                          @if (
                          formDetails.controls.additionalCostConsiderations.touched &&
                          formDetails.controls.additionalCostConsiderations.errors
                          ) {
                          <rds-control-error>{{ ERRORS.EMPTY }}</rds-control-error>
                          }
                        </rds-form-field>
                        }

                        <!-- Other pricing models Checkbox -->

                        <!-- Pricing per user -->
                        <rds-checkbox formControlName="isOtherPricingModelsAvailable" [checked]="false">{{
                          OFFERING_FORM.DETAILS.ADDITIONAL_COST.OTHER_PRICING_MODELS
                          .CHECKBOX_LABEL
                          }}</rds-checkbox>

                        @if (formDetails.controls.isOtherPricingModelsAvailable.value) {
                        <!-- Other pricing models -->
                        <rds-form-field labelPosition="top">
                          <rds-control-label>{{
                            OFFERING_FORM.DETAILS.ADDITIONAL_COST.OTHER_PRICING_MODELS
                            .LABEL
                            }}</rds-control-label>
                          <input rdsInput formControlName="otherPricingModels" [placeholder]="
                                OFFERING_FORM.DETAILS.ADDITIONAL_COST.OTHER_PRICING_MODELS
                                  .PLACEHOLDER
                              " />
                          <rds-control-hint>{{
                            OFFERING_FORM.DETAILS.ADDITIONAL_COST.OTHER_PRICING_MODELS
                            .HINT
                            }}</rds-control-hint>
                          @if (
                          formDetails.controls.otherPricingModels.touched &&
                          formDetails.controls.otherPricingModels.errors
                          ) {
                          <rds-control-error>{{ ERRORS.EMPTY }}</rds-control-error>
                          }
                        </rds-form-field>
                        }
                      </div>
                    </fieldset>

                    <!-- COMMUNITY -->
                    <fieldset class="form-box" aria-labelledby="offering-community-title">
                      <h3 class="ui-heading-3-bold mb-5" id="offering-community-title">
                        {{ OFFERING_FORM.DETAILS.COMMUNITY.SECTION_TITLE }}
                      </h3>
                      <p class="ui-body-s-bold">
                        {{ OFFERING_FORM.DETAILS.COMMUNITY.HINT }}
                      </p>
                      <table rds-table [dataSource]="communityDataSource" alternation="vertical">
                        <ng-container rdsColumnDef="title">
                          <th rds-header-cell *rdsHeaderCellDef class="required">
                            {{ OFFERING_FORM.DETAILS.COMMUNITY.TABLE_COLUMNS.TITLE }}
                          </th>
                          <td rds-cell *rdsCellDef="let element">
                            {{ element.title }}
                          </td>
                        </ng-container>

                        <ng-container rdsColumnDef="description">
                          <th rds-header-cell *rdsHeaderCellDef class="required">
                            {{
                            OFFERING_FORM.DETAILS.COMMUNITY.TABLE_COLUMNS.DESCRIPTION
                            }}
                          </th>
                          <td rds-cell *rdsCellDef="let element">
                            {{ element.description }}
                          </td>
                        </ng-container>

                        <ng-container rdsColumnDef="url">
                          <th rds-header-cell *rdsHeaderCellDef class="required">
                            {{ OFFERING_FORM.DETAILS.COMMUNITY.TABLE_COLUMNS.URL }}
                          </th>
                          <td class="last-column" rds-cell *rdsCellDef="let element">
                            {{ element.url }}
                            <div rdsDropdown class="options" autofocusFirstItem>
                              <button rds-dropdown-toggle-icon-button aria-label="More options" type="button">
                                <rds-icon namespace="outlined" icon="more_vertical" />
                              </button>
                              <div *rdsDropdownMenu>
                                <ul rds-list-item-container>
                                  <li>
                                    <button rds-list-item (click)="handleCommunityDialog(element)">
                                      {{ BUTTONS.EDIT }}
                                    </button>
                                  </li>
                                  <li>
                                    <button rds-list-item (click)="handleDeleteCommunity(element)">
                                      {{ BUTTONS.DELETE }}
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </ng-container>

                        <tr rds-header-row *rdsHeaderRowDef="communityColumns"></tr>
                        <tr rds-row *rdsRowDef="let row; columns: communityColumns"></tr>
                      </table>

                      <button class="table-action" rds-text-button (click)="handleCommunityDialog()">
                        <rds-icon icon="plus" namespace="filled" />
                        {{ OFFERING_FORM.DETAILS.COMMUNITY.CTA }}
                      </button>
                    </fieldset>

                              <!-- AI AGENT -->
          <fieldset class="form-box" aria-labelledby="offering-ai-agent-title">
            <h3 class="ui-heading-3-bold mb-5" id="offering-ai-agent-title">
              {{ OFFERING_FORM.DETAILS.AI_AGENT.SECTION_TITLE }}
            </h3>
            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.DETAILS.AI_AGENT.HINT }}
            </p>
            <table rds-table [dataSource]="agentDataSource" alternation="vertical">
              <ng-container rdsColumnDef="name">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{ OFFERING_FORM.DETAILS.AI_AGENT.TABLE_COLUMNS.NAME }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.name }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="url">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{ OFFERING_FORM.DETAILS.AI_AGENT.TABLE_COLUMNS.URL }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  {{ element.url }}
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button rds-dropdown-toggle-icon-button aria-label="More options" type="button">
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button rds-list-item (click)="handleAgentDialog(element)">
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button rds-list-item (click)="handleDeleteAgent(element)">
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="agentColumns"></tr>
              <tr rds-row *rdsRowDef="let row; columns: agentColumns"></tr>
            </table>

            <button class="table-action" rds-text-button (click)="handleAgentDialog()">
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.DETAILS.AI_AGENT.CTA }}
            </button>
          </fieldset>

        </form>
        <div class="form-actions">
          <button rds-secondary-button rdsStepperPrevious size="l">
            {{ BUTTONS.PREVIOUS_STEP }}
          </button>
          <div class="publish-and-next">
            @if (offeringUUID()) {
            <button rds-secondary-button (click)="handlePublish()" size="l" [disabled]="isPublishing()">
              @if (isPublishing()) {
              <div class="loading-container">
                <rds-progress-spinner class="loading-spinner"></rds-progress-spinner>
                {{ BUTTONS.PUBLISHING }}
              </div>
              } @else {
              {{ BUTTONS.PUBLISH }}
              }
            </button>
            }
            <button rds-primary-button rdsStepperNext size="l">
              {{ BUTTONS.NEXT_STEP }}
            </button>
          </div>
        </div>
      </rds-step>

      <!-- 4 -->
      <rds-step [stepControl]="formFunctionality" label="step_4_functionality">
        <ng-template rdsStepLabel>{{ OFFERING_FORM.STEPS.STEP_4 }}</ng-template>
        <form class="form">
          <fieldset class="form-box" aria-labelledby="offering-capabilities-title">
            <h3 class="ui-heading-3-bold mb-5 required" id="offering-capabilities-title">
              {{ OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.SECTION_TITLE }}
            </h3>

            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.HINT }}
            </p>
            <table rds-table [dataSource]="capabilityDataSource" alternation="vertical">
              <ng-container rdsColumnDef="name">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                  OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.TABLE_COLUMNS
                  .CAPABILITY_NAME
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.name }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                  OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.TABLE_COLUMNS
                  .CAPABILITY_DESCRIPTION
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.description }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="benefit">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                  OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.TABLE_COLUMNS
                  .CAPABILITY_BENEFIT
                  }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  <span>{{ element.benefit }}</span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button rds-dropdown-toggle-icon-button aria-label="More options" type="button">
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button rds-list-item (click)="handleCapabilityDialog(element)">
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button rds-list-item (click)="handleDeleteCapability(element)">
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="capabilityColumns"></tr>
              <tr rds-row *rdsRowDef="let row; columns: capabilityColumns"></tr>
            </table>

            <button class="table-action" rds-text-button (click)="handleCapabilityDialog()">
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.CTA }}
            </button>
          </fieldset>
          <fieldset class="form-box" aria-labelledby="offering-use-case-title">
            <h3 class="ui-heading-3-bold mb-5" id="offering-use-case-title">
              {{ OFFERING_FORM.FUNCTIONALITY.USE_CASES.SECTION_TITLE }}
            </h3>

            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.FUNCTIONALITY.USE_CASES.HINT }}
            </p>
            <table rds-table [dataSource]="useCaseDataSource" alternation="vertical">
              <ng-container rdsColumnDef="name">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                  OFFERING_FORM.FUNCTIONALITY.USE_CASES.TABLE_COLUMNS
                  .USE_CASE_NAME
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.name }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                  OFFERING_FORM.FUNCTIONALITY.USE_CASES.TABLE_COLUMNS
                  .USE_CASE_DESCRIPTION
                  }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  <span>{{ element.description }}</span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button rds-dropdown-toggle-icon-button aria-label="More options" type="button">
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button rds-list-item (click)="handleUseCaseDialog(element)">
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button rds-list-item (click)="handleDeleteUseCase(element)">
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="useCaseColumns"></tr>
              <tr rds-row *rdsRowDef="let row; columns: useCaseColumns"></tr>
            </table>

            <button class="table-action" rds-text-button (click)="handleUseCaseDialog()">
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.FUNCTIONALITY.USE_CASES.CTA }}
            </button>
          </fieldset>
        </form>
        <div class="form-actions">
          <button rds-secondary-button rdsStepperPrevious size="l">
            {{ BUTTONS.PREVIOUS_STEP }}
          </button>
          <div class="publish-and-next">
            @if (offeringUUID()) {
            <button rds-secondary-button (click)="handlePublish()" size="l" [disabled]="isPublishing()">
              @if (isPublishing()) {
              <div class="loading-container">
                <rds-progress-spinner class="loading-spinner"></rds-progress-spinner>
                {{ BUTTONS.PUBLISHING }}
              </div>
              } @else {
              {{ BUTTONS.PUBLISH }}
              }
            </button>
            }
            <button rds-primary-button rdsStepperNext size="l">
              {{ BUTTONS.NEXT_STEP }}
            </button>
          </div>
        </div>
      </rds-step>

      <!-- 5 -->
      <rds-step label="step_5_summary" optional>
        <ng-template rdsStepLabel>{{ OFFERING_FORM.STEPS.STEP_5 }}</ng-template>
        <div class="form">
          <section class="form-box">
            <div class="summary-bar">
              <h3 class="ui-heading-3-bold">
                {{ OFFERING_FORM.STEPS.STEP_1 }}
              </h3>
              <button rds-text-button size="l" (click)="goTo(0)">
                <rds-icon icon="edit" namespace="filled" />
                {{ BUTTONS.EDIT }}
              </button>
            </div>

            <div class="summary-container">
              <section class="summary-pair" [class.has-error]="hasError(formPermissions, 'ownerEmail')">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.PERMISSIONS.OWNER.LABEL }}
                </p>
                <div class="ui-label-l">
                  {{ summary().permissions.ownerEmail || "—" }}
                </div>
              </section>

              <section class="summary-pair" [class.has-error]="hasError(formPermissions, 'deputyEmail')">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.PERMISSIONS.DEPUTY.LABEL }}
                </p>
                <div class="ui-label-l">
                  {{ summary().permissions.deputyEmail || "—" }}
                </div>
              </section>

              <section class="summary-pair" [class.has-error]="hasError(formPermissions, 'authorEmails')">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.PERMISSIONS.AUTHOR.LABEL }}
                </p>
                <div class="ui-label-l">
                  @if (summary().permissions.authorEmails) {
                  @for (
                  a of summary().permissions.authorEmails;
                  track $index;
                  let last = $last
                  ) {
                  {{ a || "—" }}
                  @if (!last) {
                  ,
                  }
                  }
                  } @else {
                  —
                  }
                </div>
              </section>
            </div>
          </section>

          <section class="form-box">
            <div class="summary-bar">
              <h3 class="ui-heading-3-bold">
                {{ OFFERING_FORM.STEPS.STEP_2 }}
              </h3>
              <button rds-text-button size="l" (click)="goTo(1)">
                <rds-icon icon="edit" namespace="filled" />
                {{ BUTTONS.EDIT }}
              </button>
            </div>

            <div class="summary-container">
              <section class="summary-pair" [class.has-error]="hasError(formOverview, 'displayName')">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.OVERVIEW.GENERAL_INFO.DISPLAY_NAME.LABEL }}
                </p>
                <div class="ui-label-l">
                  {{ summary().overview.displayName || "—" }}
                </div>
              </section>

              <section class="summary-pair" [class.has-error]="hasError(formOverview, 'approvalStatus')">
                <p class="ui-label-m-bold">
                  {{
                  OFFERING_FORM.OVERVIEW.GENERAL_INFO.APPROVAL_STATUS.LABEL
                  }}
                </p>
                <div class="ui-label-l">
                  {{ summary().overview.approvalStatus || "—" }}
                </div>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.OVERVIEW.GENERAL_INFO.SUCCESSOR.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{
                  getOfferingById()(summary().overview.successor)
                  ?.displayName || "—"
                  }}
                </p>
              </section>

              <section class="summary-pair" [class.has-error]="hasError(formOverview, 'description')">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.OVERVIEW.DESCRIPTION.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().overview.description || "—" }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.OVERVIEW.SIMILAR_OFFERINGS.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ similarOfferingsDisplay() }}
                </p>
              </section>
            </div>
          </section>

          <section class="form-box">
            <div class="summary-bar">
              <h3 class="ui-heading-3-bold">
                {{ OFFERING_FORM.STEPS.STEP_3 }}
              </h3>
              <button rds-text-button size="l" (click)="goTo(2)">
                <rds-icon icon="edit" namespace="filled" />
                Edit
              </button>
            </div>

            <div class="summary-container">
              <section class="summary-pair" [class.has-error]="
                  hasError(formDetails, 'onboardingAccessInstructions')
                ">
                <p class="ui-label-m-bold">
                  {{
                  OFFERING_FORM.DETAILS.ONBOARDING.ACCESS_INSTRUCTIONS.LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.onboardingAccessInstructions || "—" }}
                </p>
              </section>

              <section class="summary-pair" [class.has-error]="onboardingSteps().length === 0">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.ONBOARDING.LABEL }}
                </p>
                <table rds-table [dataSource]="onboardingDataSource" alternation="vertical">
                  <ng-container rdsColumnDef="description">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.DETAILS.ONBOARDING.TABLE_COLUMNS
                      .STEP_DESCRIPTION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.description }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="referenceUrl">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.DETAILS.ONBOARDING.TABLE_COLUMNS
                      .ACCESS_URL
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.referenceUrl }}
                    </td>
                  </ng-container>

                  <tr rds-header-row *rdsHeaderRowDef="onboardingColumns"></tr>
                  <tr rds-row *rdsRowDef="let row; columns: onboardingColumns"></tr>
                </table>
              </section>

              <section class="summary-pair" [class.has-error]="servicesAndRequests().length === 0">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.SECTION_TITLE }}
                </p>
                <table rds-table [dataSource]="serviceAndRequestDataSource" alternation="vertical">
                  <ng-container rdsColumnDef="type">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                      .TYPE
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.type }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="title">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                      .TITLE
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.title }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="destinationValue">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                      .DESTINATION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.destinationValue }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="description">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                      .DESCRIPTION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.description }}
                    </td>
                  </ng-container>

                  <tr rds-header-row *rdsHeaderRowDef="serviceAndRequestColumns"></tr>
                  <tr rds-row *rdsRowDef="let row; columns: serviceAndRequestColumns"></tr>
                </table>
              </section>

              <section class="summary-pair" [class.has-error]="hasError(formDetails, 'vendorName')">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.VENDOR.NAME.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.vendorName || "—" }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.VENDOR.SUPPORT.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.vendorSupport || "—" }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.VENDOR.URL.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.vendorUrl || "—" }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.RELATED_TECHNOLOGY.SECTION_TITLE }}
                </p>
                <table rds-table [dataSource]="relatedTechnologyDataSource" alternation="vertical">
                  <ng-container rdsColumnDef="targetId">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.DETAILS.RELATED_TECHNOLOGY.TABLE_COLUMNS
                      .NAME
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ getOfferingById()(element.targetId)?.displayName || "—" }}
                    </td>
                  </ng-container>
                  <ng-container rdsColumnDef="description">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.DETAILS.RELATED_TECHNOLOGY.TABLE_COLUMNS
                      .DESCRIPTION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.description || "—" }}
                    </td>
                  </ng-container>
                  <tr rds-header-row *rdsHeaderRowDef="relatedTechnologyColumns"></tr>
                  <tr rds-row *rdsRowDef="let row; columns: relatedTechnologyColumns"></tr>
                </table>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{
                  OFFERING_FORM.DETAILS.ADDITIONAL_COST
                  .ADDITIONAL_COST_CONSIDERATIONS.CHECKBOX_LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{
                  summary().details.isAdditionalCostConsiderationsAvailable
                  ? "Yes"
                  : "No"
                  }}
                </p>
              </section>

              @if (summary().details.isAdditionalCostConsiderationsAvailable) {
              <section class="summary-pair" [class.has-error]="
                    hasError(formDetails, 'additionalCostConsiderations')
                  ">
                <p class="ui-label-m-bold">
                  {{
                  OFFERING_FORM.DETAILS.ADDITIONAL_COST
                  .ADDITIONAL_COST_CONSIDERATIONS.LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.additionalCostConsiderations || "—" }}
                </p>
              </section>
              }

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{
                  OFFERING_FORM.DETAILS.ADDITIONAL_COST.OTHER_PRICING_MODELS
                  .CHECKBOX_LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{
                  summary().details.isOtherPricingModelsAvailable
                  ? "Yes"
                  : "No"
                  }}
                </p>
              </section>

              @if (summary().details.isOtherPricingModelsAvailable) {
              <section class="summary-pair" [class.has-error]="
                    hasError(formDetails, 'otherPricingModels')
                  ">
                <p class="ui-label-m-bold">
                  {{
                  OFFERING_FORM.DETAILS.ADDITIONAL_COST.OTHER_PRICING_MODELS
                  .LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.otherPricingModels || "—" }}
                </p>
              </section>
              }

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.COMMUNITY.SECTION_TITLE }}
                </p>
                <table rds-table [dataSource]="communityDataSource" alternation="vertical">
                  <ng-container rdsColumnDef="title">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.COMMUNITY.TABLE_COLUMNS.NAME }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.title }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="description">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.DETAILS.COMMUNITY.TABLE_COLUMNS
                      .DESCRIPTION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.description }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="url">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.COMMUNITY.TABLE_COLUMNS.URL }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.url }}
                    </td>
                  </ng-container>

                  <tr rds-header-row *rdsHeaderRowDef="communityColumns"></tr>
                  <tr rds-row *rdsRowDef="let row; columns: communityColumns"></tr>
                </table>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.AI_AGENT.SECTION_TITLE }}
                </p>
                <table rds-table [dataSource]="agentDataSource" alternation="vertical">
                  <ng-container rdsColumnDef="name">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.AI_AGENT.TABLE_COLUMNS.NAME }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.name }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="url">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.AI_AGENT.TABLE_COLUMNS.URL }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.url }}
                    </td>
                  </ng-container>

                  <tr rds-header-row *rdsHeaderRowDef="agentColumns"></tr>
                  <tr rds-row *rdsRowDef="let row; columns: agentColumns"></tr>
                </table>
              </section>
            </div>
          </section>

          <section class="form-box">
            <div class="summary-bar">
              <h3 class="ui-heading-3-bold">
                {{ OFFERING_FORM.STEPS.STEP_4 }}
              </h3>
              <button rds-text-button size="l" (click)="goTo(3)">
                <rds-icon icon="edit" namespace="filled" />
                {{ BUTTONS.EDIT }}
              </button>
            </div>

            <div class="summary-container">
              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.SECTION_TITLE }}
                </p>
                <table rds-table [dataSource]="capabilityDataSource" alternation="vertical">
                  <ng-container rdsColumnDef="name">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.TABLE_COLUMNS
                      .CAPABILITY_NAME
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.name }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="description">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.TABLE_COLUMNS
                      .CAPABILITY_DESCRIPTION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      <span>{{ element.description }}</span>
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="benefit">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.TABLE_COLUMNS
                      .CAPABILITY_BENEFIT
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      <span>{{ element.benefit }}</span>
                    </td>
                  </ng-container>
                  <tr rds-header-row *rdsHeaderRowDef="capabilityColumns"></tr>
                  <tr rds-row *rdsRowDef="let row; columns: capabilityColumns"></tr>
                </table>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.FUNCTIONALITY.USE_CASES.SECTION_TITLE }}
                </p>
                <table rds-table [dataSource]="useCaseDataSource" alternation="vertical">
                  <ng-container rdsColumnDef="name">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.FUNCTIONALITY.USE_CASES.TABLE_COLUMNS
                      .USE_CASE_NAME
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.name }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="description">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                      OFFERING_FORM.FUNCTIONALITY.USE_CASES.TABLE_COLUMNS
                      .USE_CASE_DESCRIPTION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      <span>{{ element.description }}</span>
                    </td>
                  </ng-container>
                  <tr rds-header-row *rdsHeaderRowDef="useCaseColumns"></tr>
                  <tr rds-row *rdsRowDef="let row; columns: useCaseColumns"></tr>
                </table>
              </section>
            </div>
          </section>
        </div>

        <div class="form-actions">
          <button rds-secondary-button rdsStepperPrevious size="l">
            {{ BUTTONS.PREVIOUS_STEP }}
          </button>
          <div class="draft-and-publish">
            <button *inexpFeatureFlag="'focus_inexp_1361_save_draft'" rds-secondary-button (click)="handleDraftSave()" size="l"
              [disabled]="isDraftSaving()">
              @if (isDraftSaving()) {
              <div class="loading-container">
                <rds-progress-spinner class="loading-spinner"></rds-progress-spinner>
                {{ BUTTONS.DRAFT_SAVING }}
              </div>
              } @else {
              {{ BUTTONS.SAVE_DRAFT }}
              }
            </button>

            <button rds-primary-button (click)="handlePublish()" size="l" [disabled]="isPublishing()">
              @if (isPublishing()) {
              <div class="loading-container">
                <rds-progress-spinner class="loading-spinner"></rds-progress-spinner>
                {{ BUTTONS.PUBLISHING }}
              </div>
              } @else {
              {{ BUTTONS.PUBLISH }}
              }
            </button>
          </div>
        </div>
      </rds-step>
    </rds-stepper>
    }
  </div>
</div>
